import { createContext, useReducer } from "react";
import { StorageService } from "../../services";
import * as types from "./types";
import { decrypt } from "../../UtilityFunctions/utils";

const initialState = StorageService.get("conversation")
  ? JSON.parse(decrypt(StorageService.get("conversation")))
  : {};

const authReducer = (state, action) => {
  switch (action.type) {
    case types.SET_CONVERSATION:
      return {
        ...state,
        ...action.payload,
      };
    case types.CLEAR_CONVERSATION:
      return {};
    default:
      return state;
  }
};

export const ConversationContext = createContext(initialState);

const ConversationProvider = ({ children }) => {
  const [authState, authDispatch] = useReducer(authReducer, initialState);

  return (
    <ConversationContext.Provider value={[authState, authDispatch]}>
      {children}
    </ConversationContext.Provider>
  );
};

export default ConversationProvider;
